import useOpenRevievePlugin from 'components/Revieve/shared/initializeRevieveScript';
import type { RevieveActionTypes } from 'components/shared/Routing/components/CustomAction/shared/types';
import type { DefaultMenuItemProps } from '../types';
import DefaultMenuItem from './DefaultMenuItem';

export type RevieveHookMenuItemButtonProps = {
    javascriptHookType: RevieveActionTypes;
    iconUrl: DefaultMenuItemProps['iconUrl'];
    styling: DefaultMenuItemProps['styling'];
    text: string | undefined;
    isSelected: boolean;
};

export default function RevieveHookMenuItemButton({
    javascriptHookType,
    iconUrl,
    styling,
    text,
    isSelected
}: RevieveHookMenuItemButtonProps) {
    const openRevieve = useOpenRevievePlugin();

    return (
        <DefaultMenuItem.Button
            buttonProps={{
                onClick: async () => {
                    await openRevieve({ type: javascriptHookType });
                }
            }}
            iconUrl={iconUrl}
            selected={isSelected}
            styling={styling}
        >
            {text}
        </DefaultMenuItem.Button>
    );
}
